__turbopack_context__.v({
  "assistant": "EditorChat-module__N6TOzG__assistant",
  "attachment": "EditorChat-module__N6TOzG__attachment",
  "attachments": "EditorChat-module__N6TOzG__attachments",
  "chat": "EditorChat-module__N6TOzG__chat",
  "composer": "EditorChat-module__N6TOzG__composer",
  "composerActions": "EditorChat-module__N6TOzG__composerActions",
  "composerArea": "EditorChat-module__N6TOzG__composerArea",
  "context": "EditorChat-module__N6TOzG__context",
  "dropNotice": "EditorChat-module__N6TOzG__dropNotice",
  "fileIcon": "EditorChat-module__N6TOzG__fileIcon",
  "help": "EditorChat-module__N6TOzG__help",
  "jump": "EditorChat-module__N6TOzG__jump",
  "markdown": "EditorChat-module__N6TOzG__markdown",
  "message-in": "EditorChat-module__N6TOzG__message-in",
  "sentFiles": "EditorChat-module__N6TOzG__sentFiles",
  "thread": "EditorChat-module__N6TOzG__thread",
  "user": "EditorChat-module__N6TOzG__user",
  "working": "EditorChat-module__N6TOzG__working",
  "working-spin": "EditorChat-module__N6TOzG__working-spin",
});
